/**
 * InsuraDialer names for the two calling networks. Agents see these, never the carriers:
 * Classic = Twilio, Next = Telnyx. The dialer runs on the system of the agent's default
 * number, so "switching" = making a number on the other system the default.
 */
export type DialerCarrier = "twilio" | "telnyx";

export const DIALER_SYSTEMS: Record<DialerCarrier, { name: string; short: string; blurb: string }> = {
  twilio: { name: "InsuraDialer Classic", short: "Classic", blurb: "The calling network your numbers run on today." },
  telnyx: { name: "InsuraDialer Next", short: "Next", blurb: "Our next-generation calling network." },
};

export const carrierOf = (provider?: string | null): DialerCarrier => (provider === "telnyx" ? "telnyx" : "twilio");

export const otherSystem = (c: DialerCarrier): DialerCarrier => (c === "telnyx" ? "twilio" : "telnyx");

type NumberRow = { phoneNumber?: string; number?: string; provider?: string | null; status?: string; isActive?: boolean };

/** What switching to `target` means for this agent's numbers. */
export function switchPlan(target: DialerCarrier, numbers: NumberRow[]) {
  const active = numbers.filter((n) => n.isActive !== false && (n.status ?? "active") === "active");
  const onTarget = active.filter((n) => carrierOf(n.provider) === target);
  return {
    /** Becomes the default number: that is the switch. Null = they need a number on `target` first. */
    useNumber: onTarget[0]?.phoneNumber ?? onTarget[0]?.number ?? null,
    /** Numbers left on the other system: they can't make or take calls on `target` until transferred. */
    leftBehind: active.length - onTarget.length,
  };
}
